import React from "react";
import { PANEL, StrokeIcon } from "./ui";

const ErrorModal = ({ errorMessage, title = "Upload Failed" }) => (
  <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4">
    <div className={`w-full max-w-sm border-rose-500/60 px-8 py-10 text-center ${PANEL}`}>
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-rose-500/15 text-rose-500">
        <StrokeIcon className="h-8 w-8 animate-shake">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 8v4M12 16h.01" />
        </StrokeIcon>
      </div>
      <h3 className="mt-5 text-xl font-extrabold text-gray-900 dark:text-white">{title}</h3>
      <p className="mt-2 break-words text-sm text-gray-500 dark:text-slate-400">{errorMessage}</p>
    </div>
  </div>
);

export default ErrorModal;
